module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAIKADAAQAAAABAAAAGAAAAAA915G0AAAAnUlEQVRIDWPcuO+I+u07D/d/+/5DkoGOgIuT47mqirwjs4m182V6Ww7y5+8/f3g/f/4azAKzvDg9jo7+Z2DonbmIAWQ3E11txWLZqANGQ2A0BEZDgHEyA8N/UPngpSqNpZigndC220/Bho9GwWgIjIbAaAgMeAgwzmRmevbr7z+6tohh5Ss7M9MTJgkubkc2ZqYXMEF60SDLxbm4XQCn2CsNNCuZvAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/flag-pl@2x.png
// module id = 507
// module chunks = 9